import axios from "axios";
import { API_BASE_URL } from "../config/Base_Url_Config";


// <-------- get the terms & condtions -------->
export const get_knowledge_centres_data = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/knowledge-centres-data`);
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- get the terms & condtions -------->
export const get_knowledge_centres_details = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/knowledge-centres-data`, {
      params: {
        id: id,
      }
    });
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- get the terms & condtions -------->
export const get_faqs_data = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/faq-data`);
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- blog-data -------->
export const get_blog_data = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/blog-data`);
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- blog-data -------->
export const get_blog_details = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/blog-data`, {
      params: {
        id: id,
      }
    });
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- blog-data -------->
export const get_hosting_data = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/hosting-data`);
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- get_terms_conditions_data -------->
export const get_terms_conditions_data = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/terms-conditions`);
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- get_terms_conditions_data -------->
export const get_privacy_policy_data = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/privacy-policy`);
    return response;
  } catch (error) {
    return error;
  }
}

// <------------ add to cart --------->
export const add_payment = async (data, header) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/payment`, data, {
      headers: header
    });

    return response;
  } catch (error) {
    return error;
  }
}

// <-------- get_terms_conditions_data -------->
export const get_main_banner_section = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-banners`);
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- get_terms_conditions_data -------->
export const get_settings_section = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-settings`);
    return response;
  } catch (error) {
    return error;
  }
}
// <---------------- get pages------------------>
export const get_pages_section = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-pages`);
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- get_terms_conditions_data -------->
export const get_features_section = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-features`);
    return response;
  } catch (error) {
    return error;
  }
}

// <-------- get_terms_conditions_data -------->
export const get_development = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-development`);
    return response;
  } catch (error) {
    return error;
  }
}
